import ControlModel from "../../models/controlModel";
import { MODEL_CONTROL_TYPE } from "../../utils/enums";

export function createFilterControlModel({ ...args }) {
  return new ControlModel({ ...args, type: MODEL_CONTROL_TYPE.filter });
}